export default __webpack_public_path__ + "static/media/misc-drawerA-480w.2853c323.webp";